import { render, staticRenderFns } from "./ChurnDescriptionPopupContent.vue?vue&type=template&id=51660ed9&scoped=true&"
import script from "./ChurnDescriptionPopupContent.vue?vue&type=script&lang=js&"
export * from "./ChurnDescriptionPopupContent.vue?vue&type=script&lang=js&"
import style0 from "./ChurnDescriptionPopupContent.vue?vue&type=style&index=0&id=51660ed9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51660ed9",
  null
  
)

export default component.exports